<div class="trades-container">
  <ag-grid-angular
    [enableRangeSelection]="true"
    class="ag-theme-balham-dark trades-container__ag-grid"
    [columnDefs]="$any(tradeHeaders)"
    [autoGroupColumnDef]="{ sortable: true }"
    rowSelection="multiple"
    [groupSelectsChildren]="true"
    [suppressRowClickSelection]="true"
    [sideBar]="sideBarDef"
    (selectionChanged)="onSelectionChanged()"
    (gridReady)="onGridReady($event)"
    (sortChanged)="gridStateChanged($event)"
    (columnResized)="gridStateChanged($event)"
    (columnVisible)="gridStateChanged($event)"
    (columnMoved)="gridStateChanged($event)"
    (columnPivotChanged)="gridStateChanged($event)"
    (columnRowGroupChanged)="gridStateChanged($event)"
    (columnValueChanged)="gridStateChanged($event)"
    (columnMoved)="gridStateChanged($event)"
    (columnPinned)="gridStateChanged($event)"
    (filterChanged)="filterChanged($event)"
    overlayLoadingTemplate="<span class='ag-overlay-loading-center'>Updating trades</span>"
  >
  </ag-grid-angular>

  <div class="trades-container__footer">
    <div
      class="trades-container__footer__num-of-trades-displayed"
      *ngIf="numberOfTradesDisplayed != null"
    >
      {{ numberOfTradesDisplayed }} Trades
      <span *ngIf="hasFilters()">(after filtering)</span>
    </div>
    <div class="last-updated">Last updated: {{ lastUpdatedAtStr }}</div>
    <div class="trades-container__footer__buttons">
      <div class="max-trades" *ngIf="selectedTrades?.length > maxTrades">
        Maximum {{ maxTrades }} trades ({{ selectedTrades?.length }} selected)
      </div>

      <div class="historical-trades" *ngIf="isHistoricalTrades">
        <ng-container *ngIf="historicalTradesMeta">
          Historical trades loaded for {{ historicalTradesMeta?.datetime }}
          {{ historicalTradesMeta?.timezone }}
        </ng-container>
        <ng-container *ngIf="!historicalTradesMeta">
          Historical trades loading...
        </ng-container>
        <button
          type="button"
          class="ui-button ui-button__footer"
          (click)="loadTrades()"
        >
          Show live trades
        </button>
      </div>

      <button
        type="button"
        class="ui-button ui-button__footer"
        (click)="loadTrades()"
      >
        Update
      </button>

      <button
        type="button"
        class="ui-button ui-button__footer"
        (click)="loadTradesClick()"
        [disabled]="!buttonsEnabled"
      >
        Load
      </button>

      <button
        type="button"
        class="ui-button ui-button__footer historical-trades-btn"
        (click)="openLoadHistoricalTrades()"
      >
        Historical trades
      </button>

      <button
        type="button"
        class="ui-button ui-button__footer trade-manager-btn"
        (click)="openTradeManager()"
      >
        Trade Manager
      </button>

      <button
        type="button"
        class="ui-button ui-button__footer save-deal-btn"
        (click)="saveDeal()"
        [disabled]="!enableDealSTP"
      >
        Book & STP Trades
      </button>

      <button
        type="button"
        class="ui-button ui-button__footer save-deal-btn"
        (click)="clearFilters()"
        [disabled]="!hasFilters()"
      >
        <cds-icon shape="filter-grid"></cds-icon>
        Clear Filters
      </button>
    </div>
  </div>
</div>

<app-load-portfolio
  [modalOpened]="isLoadHistoricalTradesOpen"
  *ngIf="isLoadHistoricalTradesOpen"
  (modalOpenedChange)="openLoadHistoricalTrades($event)"
  (dataLoaded)="loadHistoricalTrades($event)"
>
</app-load-portfolio>

<app-trade-manager
  [isModalOpened]="isTradeManagerOpen"
  [selectedTrades]="selectedTrades"
  *ngIf="isTradeManagerOpen"
  (modalStateChanged)="openTradeManager($event)"
></app-trade-manager>
